import { useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";

function Footer() {

    return (
        <>
            {/* <!-- BEGIN: Dark Mode Switcher--> */}
            < div className="text-start pt-10 position-absolute bottom-0" >
                <div class="cursor-pointer w-full d-flex align-items-center justify-content-start z-50">
                    <div class="me-1 text-white fs-base">© </div>
                    <img src="/images/Blue-Worl-Innovation-white-text.png" className="w-8 " alt="" />
                    <div class="text-white fs-base">&nbsp; All Rights Reserved</div>
                </div>
            </div >
            {/* <!-- END: Dark Mode Switcher--> */}
        </>
    )
}

export default Footer;